import React, { useEffect, useState } from "react";
import { ListContentWrap, PageArticleWrap, PageHeaderTitleButtonStyle } from "components/layout/Layout";
import { SingleResult, SiteInfo, SitePostType } from "../../type/type";
import Loading from "components/Loading";
import { getSiteOne, updateSiteHandler } from "../../api/api";
import { OutlinePrimaryBtn, SolidPrimarySubBtn } from "components/button/Button";
import { FlexWrapR, InputWrapC, InputWrapR } from "components/common/CommonLayout";
import { formattedHHMM } from "utils/commonUtils";
import styled from "styled-components";
import { colors } from "styles/global-styles";
import { RoundIcon } from "components/common/Icon";

const EqualHeight = styled.p`
    display: flex;
    align-items: center;
    gap: 0.25rem;
    line-height: 1.5;

    .asterisk {
        font-size: 1rem;
        line-height: 1.25;
    }
    .strong-text {
        color: ${colors.primaryHover};
        font-weight: 600;
    }
`;

/**
 * 평일/주말 등/하교 인정 시간대 설정
 */
interface CheckTime {
    check_in_start_time: string; //등교 시작 시간 yy:mm:dd
    check_in_end_time: string; //등교 종료 시간
    check_out_start_time: string; //하교 시작 시간
    check_out_end_time:  string; //하교 종료 시간
    holiday_check_in_start_time: string; // 주말 등교 시작 시간 yy:mm:dd
    holiday_check_in_end_time: string; // 주말 등교 종료 시간
    holiday_check_out_start_time: string; // 주말 하교 시작 시간
    holiday_check_out_end_time: string; // 주말 하교 종료 시간
}

export const SchoolTime = () => {

    const [loading, setLoading] = useState<boolean>(false);

    const [btnToggle, setBtnToggle] = useState(false);

    const [siteObj, setSiteObj] = useState<CheckTime>({
        check_in_start_time: "",
        check_in_end_time: "",
        check_out_start_time: "",
        check_out_end_time: "",
        holiday_check_in_start_time: "",
        holiday_check_in_end_time: "",
        holiday_check_out_start_time: "",
        holiday_check_out_end_time: "",
    });

    //정보 수정 시 필요한 정보
    const [requestSite, setRequestSite] = useState<SitePostType>({
        name: "",
        full_address: "",
        detail_address: "",
        phone: "",
        fax: "",
        email: "",
        temp_phone: "",
        approval: 0,
        base64_list: [],
        check_in_start_time: "",
        check_in_end_time: "",
        check_out_start_time: "",
        check_out_end_time: "",
        holiday_check_in_start_time: "",
        holiday_check_in_end_time: "",
        holiday_check_out_start_time: "",
        holiday_check_out_end_time: "",
    });

    // 유효성 검사
    const [isValidNum, setIsValidNum] = useState(0);
    const [errorMsg, setErrorMsg] = useState("");
    const [vaild, setIsVaild] = useState(false); // 유효성 검사 최종 결과

    // 정보 수정 input 값 변경
    function changeRequestSite(e: React.ChangeEvent<HTMLInputElement>):void {
        const {name, value} = e.target;
        setRequestSite({ ...requestSite, [name]: value });
    }

    // 등/하교 시간 유효성 검사
    function vaildCheckTime() {
        
        const allTimesEnter = requestSite.check_in_start_time && requestSite.check_in_end_time && requestSite.check_out_start_time && requestSite.check_out_end_time
            && requestSite.holiday_check_in_start_time && requestSite.holiday_check_in_end_time && requestSite.holiday_check_out_start_time && requestSite.holiday_check_out_end_time;

        // 시간 모두 입력했는지 확인
        if (!allTimesEnter) {
            setIsVaild(false);
            return;
        }

        // 검사할 시간 배열
        const timeChecks = [
            { start: requestSite.check_in_start_time, end: requestSite.check_in_end_time, num: 1, msg: "등교 시작 시간이 종료 시간보다 늦을 수 없습니다." },
            { start: requestSite.check_out_start_time, end: requestSite.check_out_end_time, num: 3, msg: "하교 시작 시간이 종료 시간보다 늦을 수 없습니다." },
            { start: requestSite.check_in_start_time, end: requestSite.check_out_start_time, num: 3, msg: "하교 시작 시간이 등교 시작 시간보다 빠를 수 없습니다." },
            { start: requestSite.check_in_end_time, end: requestSite.check_out_end_time, num: 4, msg: "하교 종료 시간이 등교 종료 시간보다 빠를 수 없습니다." },
            { start: requestSite.holiday_check_in_start_time, end: requestSite.holiday_check_in_end_time, num: 5, msg: "등교 시작 시간이 종료 시간보다 늦을 수 없습니다." },
            { start: requestSite.holiday_check_out_start_time, end: requestSite.holiday_check_out_end_time, num: 7, msg: "하교 시작 시간이 종료 시간보다 늦을 수 없습니다." },
            { start: requestSite.holiday_check_in_start_time, end: requestSite.holiday_check_out_start_time, num: 7, msg: "하교 시작 시간이 등교 시작 시간보다 빠를 수 없습니다." },
            { start: requestSite.holiday_check_in_end_time, end: requestSite.holiday_check_out_end_time, num: 8, msg: "하교 종료 시간이 등교 종료 시간보다 빠를 수 없습니다." },
        ];
        
        for (const check of timeChecks) {
            if (check.start !== undefined && check.end !== undefined) {
                if (check.start >= check.end) {
                    setIsValidNum(check.num);
                    setErrorMsg(check.msg);
                    setIsVaild(false);
                    return; // 에러 발견 시 바로 함수 종료
                }
            }
        }

        setIsValidNum(0);
        setErrorMsg("");
        setIsVaild(true);

    }

    // 수정 취소
    async function cancleTime(): Promise<void> {
        setRequestSite({
            ...requestSite,
            check_in_start_time: siteObj.check_in_start_time,
            check_in_end_time: siteObj.check_in_end_time,
            check_out_start_time: siteObj.check_out_start_time,
            check_out_end_time: siteObj.check_out_end_time,
            holiday_check_in_start_time: siteObj.holiday_check_in_start_time,
            holiday_check_in_end_time: siteObj.holiday_check_in_end_time,
            holiday_check_out_start_time: siteObj.holiday_check_out_start_time,
            holiday_check_out_end_time: siteObj.holiday_check_out_end_time,
        })

        setBtnToggle(prev => !prev);
        setIsVaild(false);
    }

    //정보 수정
    async function updateTime():Promise<void>{
        try {

            const response = await updateSiteHandler(requestSite);
            if(response.code === 200){
                alert("학교 정보가 수정되었습니다.");
                setBtnToggle(false);
            }
            else{
                alert("학교 정보 수정에 실패하였습니다.");
            }
            getSite();

        }
        catch (err) {
            console.error(err);
        }
    }

    async function getSite(){
        try {
            const res:SingleResult<SiteInfo> = await getSiteOne();

            if (res.code === 200) {

                const site = res.data;
                setRequestSite({
                    name: site.name,
                    full_address: site.road_address,
                    detail_address: site.detail_address,
                    phone: site.phone,
                    fax: site.fax,
                    email: site.email,
                    temp_phone: site.temp_phone,
                    approval: site.approval,
                    base64_list: [],
                    check_in_start_time: formattedHHMM(site.check_in_start_time || ""),
                    check_in_end_time: formattedHHMM(site.check_in_end_time || ""),
                    check_out_start_time: formattedHHMM(site.check_out_start_time || ""),
                    check_out_end_time: formattedHHMM(site.check_out_end_time || ""),
                    holiday_check_in_start_time: formattedHHMM(site.holiday_check_in_start_time || ""),
                    holiday_check_in_end_time: formattedHHMM(site.holiday_check_in_end_time || ""),
                    holiday_check_out_start_time: formattedHHMM(site.holiday_check_out_start_time || ""),
                    holiday_check_out_end_time: formattedHHMM(site.holiday_check_out_end_time || ""),
                });

                setSiteObj({
                    check_in_start_time: formattedHHMM(site.check_in_start_time || ""),
                    check_in_end_time: formattedHHMM(site.check_in_end_time || ""),
                    check_out_start_time: formattedHHMM(site.check_out_start_time || ""),
                    check_out_end_time: formattedHHMM(site.check_out_end_time || ""),
                    holiday_check_in_start_time: formattedHHMM(site.holiday_check_in_start_time || ""),
                    holiday_check_in_end_time: formattedHHMM(site.holiday_check_in_end_time || ""),
                    holiday_check_out_start_time: formattedHHMM(site.holiday_check_out_start_time || ""),
                    holiday_check_out_end_time: formattedHHMM(site.holiday_check_out_end_time || "")
                });
            }
        }
        catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        setLoading(true);
        getSite();
    }, []);

    useEffect(() => {
        vaildCheckTime();
    }, [requestSite]);
    

    return (
        loading ? <Loading />
        : 
            <>
                <PageHeaderTitleButtonStyle>
                    <p className="header-title">출석부 설정</p>
                </PageHeaderTitleButtonStyle>

                <PageArticleWrap>
                    <article className="list-content-container" style={{gap: '1.5rem',overflow:'auto'}}>
                        <div className="article-header height-auto">
                            <p>
                                <span className="article-header-title">등하교 인정 시간대</span>
                            </p>
                            {!btnToggle ?
                                <SolidPrimarySubBtn type="button" onClick={() => { setBtnToggle(prev => !prev) }}>
                                    수정
                                </SolidPrimarySubBtn>
                                :
                                <FlexWrapR $alignItems="center" $gap="1rem">
                                    <OutlinePrimaryBtn type="button" onClick={() => { cancleTime() }}>
                                        취소
                                    </OutlinePrimaryBtn>
                                    <SolidPrimarySubBtn type="button" onClick={() => { updateTime() }} disabled={!vaild}>
                                        저장
                                    </SolidPrimarySubBtn>
                                </FlexWrapR>
                            }
                        </div>
                        <ListContentWrap style={{ height: 'auto' }}>
                            <InputWrapR $gap="1rem" style={{flexWrap: 'wrap'}}>
                                <p style={{ width: '100%' }}>
                                    <RoundIcon text="평일" type=""/>
                                </p>
                                <InputWrapC style={{width: 'auto', marginLeft: '4rem'}}>
                                    <label>등교 시간</label>
                                    <InputWrapR $alignItems={'center'}>
                                        <input 
                                            type="time"
                                            name="check_in_start_time" 
                                            value={requestSite.check_in_start_time}
                                            onChange={changeRequestSite}
                                            readOnly={!btnToggle}
                                            className={isValidNum === 1 ? "time-false" : ""}
                                        />
                                        <span>~</span>
                                        <input 
                                            type="time"
                                            name="check_in_end_time" 
                                            value={requestSite.check_in_end_time}
                                            onChange={changeRequestSite}
                                            readOnly={!btnToggle}
                                            className={isValidNum === 2? "time-false" : ""}
                                        />
                                    </InputWrapR>
                                </InputWrapC>
                                <InputWrapC style={{width: 'auto'}}>
                                    <label>하교 시간</label>
                                    <InputWrapR $alignItems={'center'}>
                                        <input 
                                            type="time"
                                            name="check_out_start_time"
                                            value={requestSite.check_out_start_time}
                                            onChange={changeRequestSite}
                                            readOnly={!btnToggle}
                                            className={isValidNum === 3? "time-false" : ""}
                                        />
                                        <span>~</span>
                                        <input 
                                            type="time"
                                            name="check_out_end_time"
                                            value={requestSite.check_out_end_time}
                                            onChange={changeRequestSite}
                                            readOnly={!btnToggle}
                                            className={isValidNum === 4? "time-false" : ""}
                                        />
                                    </InputWrapR>
                                </InputWrapC>
                                {(isValidNum > 0 && isValidNum < 5) && <p className="text-red" style={{ marginLeft: '1rem', marginTop: 'auto' }}>{errorMsg}</p>}
                            </InputWrapR>

                            <InputWrapR $gap="1rem" style={{flexWrap: 'wrap'}}>
                                <p style={{ width: '100%' }}>
                                    <RoundIcon text="주말" type="orange"/>
                                </p>
                                <InputWrapC style={{width: 'auto', marginLeft: '4rem'}}>
                                    <label>등교 시간</label>
                                    <InputWrapR $alignItems={'center'}>
                                        <input 
                                            type="time"
                                            name="holiday_check_in_start_time" 
                                            value={requestSite.holiday_check_in_start_time}
                                            onChange={changeRequestSite}
                                            readOnly={!btnToggle}
                                            className={isValidNum === 5 ? "time-false" : ""}
                                        />
                                        <span>~</span>
                                        <input 
                                            type="time"
                                            name="holiday_check_in_end_time" 
                                            value={requestSite.holiday_check_in_end_time}
                                            onChange={changeRequestSite}
                                            readOnly={!btnToggle}
                                            className={isValidNum === 6 ? "time-false" : ""}
                                        />
                                    </InputWrapR>
                                </InputWrapC>
                                <InputWrapC style={{width: 'auto'}}>
                                    <label>하교 시간</label>
                                    <InputWrapR $alignItems={'center'}>
                                        <input 
                                            type="time"
                                            name="holiday_check_out_start_time"
                                            value={requestSite.holiday_check_out_start_time}
                                            onChange={changeRequestSite}
                                            readOnly={!btnToggle}
                                            className={isValidNum === 7 ? "time-false" : ""}
                                        />
                                        <span>~</span>
                                        <input 
                                            type="time"
                                            name="holiday_check_out_end_time"
                                            value={requestSite.holiday_check_out_end_time}
                                            onChange={changeRequestSite}
                                            readOnly={!btnToggle}
                                            className={isValidNum === 8 ? "time-false" : ""}
                                        />
                                    </InputWrapR>
                                </InputWrapC>
                                {isValidNum > 4 && <p className="text-red" style={{ marginLeft: '1rem', marginTop: 'auto' }}>{errorMsg}</p>}
                            </InputWrapR>
                            <InputWrapC style={{marginTop: '4rem', fontSize: '0.75rem', color: colors.darkGray}}>
                                <EqualHeight><span className="asterisk">*</span>등교/하교 시간대는 해당 시간대에 <span className="strong-text">출결 기기로 인증 시 허용되는 시간대</span>를 의미합니다.</EqualHeight>
                                <EqualHeight><span className="asterisk">*</span>각 시간대의 <span className="strong-text">등교 푸시 알림은 1번만</span> 적용되며, <span className="strong-text">하교 푸시 알림은 인증 시마다</span> 적용될 수 있습니다.</EqualHeight>
                            </InputWrapC>
                        </ListContentWrap>
                    </article>
                </PageArticleWrap>
            </>
    );
}